<template>
    <div class="d-doughnut">
        <svg class="progress-ring" :width="radius * 2 + 20" :height="radius * 2 + 20">
            <circle
                class="progress-ring__bg"
                :stroke-width="strokeWidth"
                fill="transparent"
                :r="radius"
                :cx="radius + 10"
                :cy="radius + 10"
            />
            <circle
                v-for="(item, index) in items"
                :key="index"
                ref="ring"
                class="progress-ring__circle"
                :class="{ hide: item === 0 }"
                :stroke-width="strokeWidth"
                fill="transparent"
                :r="radius"
                :cx="radius + 10"
                :cy="radius + 10"
                :style="`stroke: ${colors[index]}; stroke-dashoffset: ${getOffset(
                    items[index],
                )}; stroke-dasharray: ${circumference} ${circumference}; transform: rotate(${rotations[index]}deg)`"
            />
            <text v-if="showCount" class="text-color" font-size="2em" x="50%" y="50%" text-anchor="middle">
                {{ totalCount }}
            </text>
            <text v-if="showCount" class="text-color" font-size="1em" dy="1.2em" x="50%" y="50%" text-anchor="middle">
                visitors
            </text>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'DDoughnut',
    props: {
        items: {
            type: Array,
            required: true,
        },
        colors: {
            type: Array,
            required: true,
        },
        radius: {
            type: Number,
            default: 61,
        },
        showCount: {
            type: Boolean,
            default: false,
        },
        totalCount: {
            type: Number,
            default: undefined,
        },
    },
    data() {
        return {
            strokeWidth: 5,
        }
    },
    computed: {
        circumference() {
            return Math.floor(this.radius * 2 * Math.PI)
        },
        rotations() {
            let total = 0,
                rotations = []

            for (const item of this.items) {
                rotations.push(total * 360)
                total += item
            }

            return rotations.map((el) => el - 90)
        },
    },
    methods: {
        getOffset(value) {
            return this.circumference - (value - 2 / 100) * this.circumference
        },
    },
}
</script>

<style scoped lang="sass">
.d-doughnut
    svg
        .progress-ring__circle
            transform: rotate(-90deg)
            stroke-linecap: round
            transform-origin: center
            +transition(200ms)

            &.hide
                display: none

        .progress-ring__bg
            stroke: $gray-1

        .text-color
            fill: $neutral-3
</style>
